import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const ExternalOrder = forwardRef(function ExternalOrder(props, ref) {
  const { color = '#000000', size = 16, ...others } = props;

  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 16 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z"
        fill={color}
      />
      <path
        d="M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z"
        fill={color}
      />
      <path
        d="M13.5358 6.87352H10.7022C9.9568 6.87352 9.35112 6.26785 9.35112 5.5224V2.68462C9.35112 1.93917 9.9568 1.3335 10.7022 1.3335H13.5358C14.2812 1.3335 14.8869 1.93917 14.8869 2.68462V5.51816C14.8869 6.26785 14.2812 6.87352 13.5358 6.87352Z"
        fill={color}
      />
      <path
        d="M5.52224 14.6665H2.68446C1.93901 14.6665 1.33334 14.0608 1.33334 13.3111V10.4776C1.33334 9.73214 1.93901 9.12646 2.68446 9.12646H5.518C6.26345 9.12646 6.86912 9.73214 6.86912 10.4776V13.3111C6.87336 14.0608 6.26768 14.6665 5.52224 14.6665Z"
        fill={color}
      />
      <path
        d="M13.5358 14.6666H10.7022C9.9568 14.6666 9.35112 14.061 9.35112 13.3155V10.482C9.35112 9.73654 9.9568 9.13086 10.7022 9.13086H13.5358C14.2812 9.13086 14.8869 9.73654 14.8869 10.482V13.3155C14.8869 14.061 14.2812 14.6666 13.5358 14.6666Z"
        fill={color}
      />
      <path
        d="M5.52224 6.87352H2.68446C1.93901 6.87352 1.33334 6.26785 1.33334 5.5224V2.68885C1.33334 1.93917 1.93901 1.3335 2.68446 1.3335H5.518C6.26345 1.3335 6.86912 1.93917 6.86912 2.68462V5.51816C6.87336 6.26785 6.26768 6.87352 5.52224 6.87352Z"
        fill={color}
      />
    </svg>
  );
});

ExternalOrder.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ExternalOrder;
